import type { MarkFoundPromptVariant } from '@repo/types/analytic-events/maps-analytic-events';

export const MARK_FOUND_PROMPT_EXPERIMENT = 'mark_found_download_prompt';
export const MARK_FOUND_PROMPT_VARIANT_COOKIE = 'wand_mark_found_prompt_variant';

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export function getOrAssignMarkFoundPromptVariant(
    cookieString: string,
    random: () => number = Math.random,
): MarkFoundPromptVariant {
    const match = cookieString.match(new RegExp(`(?:^|; )${MARK_FOUND_PROMPT_VARIANT_COOKIE}=([^;]*)`));
    const storedVariant = match?.[1];

    if (storedVariant === 'signup' || storedVariant === 'download') {
        return storedVariant;
    }

    return random() < 0.5 ? 'signup' : 'download';
}

export function persistMarkFoundPromptVariant(variant: MarkFoundPromptVariant): void {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    // biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API is not supported in every target browser.
    document.cookie = `${MARK_FOUND_PROMPT_VARIANT_COOKIE}=${variant}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secure}`;
}
